import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { useStrategy } from '../../hooks/useStrategy';
import { useTranslationHelpers } from '../../hooks/useTranslationHelpers';
import { PASS } from '../../filterQueryFormat/MatchStatus';
import FilterOperatorDisplay from '../operator/FilterOperatorDisplay';
import { isPropertyNameAndValueCondition } from '../../strategy/propertyChangedFilterUtils';
import ViewerPropertyNameAndValueCondition from './ViewerPropertyNameAndValueConditionDisplay';
import { hasFieldOverrideV2 } from '../../permissions/gates';
import { Map as ImmutableMap } from 'immutable';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerConditionDisplay = props => {
  const {
    filterFamily,
    testFilterData,
    condition,
    parentLogicGroup
  } = props;
  const {
    currencyCode,
    data,
    getIsUngated,
    props: {
      translationPrefix
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getFieldDefinitions,
    getValueResolver,
    getReferencedObjectType,
    getSpecialOptionsForReferenceType,
    getFilterFamilyObjectName,
    isTestFiltersEnabled,
    getOperatorsForType
  } = useStrategy();
  const {
    getFieldLabelString
  } = useTranslationHelpers(filterFamily);
  if (isPropertyNameAndValueCondition(condition)) {
    return /*#__PURE__*/_jsx(ViewerPropertyNameAndValueCondition, {
      condition: condition
    });
  }
  const sharedProps = {
    currencyCode,
    getIsUngated,
    data,
    fieldDefinitions: hasFieldOverrideV2(getIsUngated) ? ImmutableMap({}) : getFieldDefinitions(filterFamily),
    filterFamily,
    getFamilyValueResolver: getValueResolver.bind(null, filterFamily),
    getFilterFamilyObjectName,
    getLabelString: getFieldLabelString,
    getReferencedObjectType: getReferencedObjectType.bind(null, filterFamily),
    getSpecialOptionsForReferenceType,
    includeObjectsWithNoAssociatedObjects: parentLogicGroup.includeObjectsWithNoAssociatedObjects,
    isReadOnly: true,
    isXoEnabled: true,
    hideRestrictedAsset: true,
    translationPrefix,
    getOperatorsForType
  };
  const matchingFilterValues = condition.constructor.isIterableField('value') ? testFilterData && testFilterData.matchingFilterValues : undefined;
  const isMatchingEmptyPropertyValue = testFilterData && testFilterData.status === PASS && matchingFilterValues && matchingFilterValues.length === 0;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FilterOperatorDisplay, Object.assign({}, sharedProps, {
      matchingFilterValues: isTestFiltersEnabled ? matchingFilterValues : undefined,
      isMatchingEmptyPropertyValue: isTestFiltersEnabled ? isMatchingEmptyPropertyValue : undefined,
      operator: condition
    })), condition.dateRefinement && /*#__PURE__*/_jsx(FilterOperatorDisplay, Object.assign({}, sharedProps, {
      operator: condition.dateRefinement
    })), condition.numberRefinement && /*#__PURE__*/_jsx(FilterOperatorDisplay, Object.assign({}, sharedProps, {
      operator: condition.numberRefinement
    }))]
  });
};
export default ViewerConditionDisplay;